import React from 'react'
import Link from 'gatsby-link';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      sticky: false
    };
  }
  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  // open menu on mobile
  showMenuBtn = () => {
    if ($(window).width() < 1200) {
      $(".open_menu").addClass("visible");
      $("header nav").addClass("hidden");
      $(".navigation_mobile").removeClass("opened");
    }
    else {
      $(".open_menu").removeClass("visible");
      $("header nav").removeClass("hidden");
      $(".navigation_mobile").removeClass("opened");
    }
  }

  makeNavFollow = () => {
    if(!this.header){
      return;
    }
    const sticky = window.pageYOffset > this.header.offsetTop;
    this.setState({sticky});
  }

  componentWillUnmount() {
    $(window).off('resize', this.showMenuBtn.bind(this));
    $(window).off('scroll', this.makeNavFollow.bind(this));
  }

  componentDidMount() {
    $(window).on('resize', this.showMenuBtn.bind(this));
    $(window).on('scroll', this.makeNavFollow.bind(this));
    $(window).trigger("resize");
    $(".open_menu").click(function() {
      $(".navigation_mobile").addClass("opened");
    });

    $(".close_menu, header, section, .navigation_mobile .inner a").click(function() {
      $(".navigation_mobile").removeClass("opened");
    });
  }
  render() {
    const {t, i18n, alwaysSticky} = this.props;
    let language = 'en';
    if(i18n.language && i18n.language !== 'en'){
      language = i18n.language;
    }
    const path = window.location.pathname.replace(`${language}/`, '');
    return (
      <div className={`component-Header ${this.state.sticky || alwaysSticky ? 'component-Header__sticky' : ''}`} ref={header => this.header = header}>
          <a className="open_menu" href="#"><i className="fa fa-bars"></i></a>
          <div className="navigation_mobile type4 bg_white">
          	<a className="close_menu blue" href="#"><i className="fa fa-close"></i></a>

          	<div className="padding_top30 padding_bottom60 inner">
            	<Link to={`/${language === 'en' ? '' : language }`} className="left40">
            	  <img src="/images/duuers-logo.png" className="height40"/>
            	</Link>
          		<a href={`https://app.duuers.com/auth/login?lng=${i18n.language}`} className="top20 left40 btn size40 transparent_blue border radius6 uppercase spacing15 font12 padding_sides20">{t('menu.login')}</a>
          		<a href={`https://app.duuers.com/auth/signup?lng=${i18n.language}`} className="top20 left40 bottom40 btn size40 blue border radius6 uppercase spacing15 font12 padding_sides20">{t('menu.signup')}</a>

          		<div className="hr height1 blue opacity1"></div>
          		<Link className="left40 font_second font22 line_height70 link blue" to={`/${language}/features`}>{t('menu.howitworks')}</Link>
          		<div className="hr height1 blue opacity1"></div>
          		<Link className="left40 font_second font22 line_height70 link blue" to={`/${language === 'en' ? '' : language}/#references`}>{t('menu.references')}</Link>
          		<div className="hr height1 blue opacity1"></div>
          		<Link className="left40 font_second font22 line_height70 link blue" to={`/${language === 'en' ? '' : language}/#pricing`}>{t('menu.pricing')}</Link>
              <div className="hr height1 blue opacity1"></div>
              <Link className="left40 font_second font22 line_height70 link blue" to={`/${language}/about`}>{t('menu.about')}</Link>

          		<div className="left40 top40 links">
  		          <Link className="link blue light" to={path === '/' ? '/' : `/en/${path}`} onClick={()=>{i18n.changeLanguage('en')}}>EN</Link>
  		          <Link className="link blue light sides10" to={`/fi/${path}`} onClick={()=>{i18n.changeLanguage('fi')}}>FI</Link>
          		</div>

          		<div className="left40 top110 links">
                <div><Link className="font12 semibold link opacity3 uppercase spacing15 bottom20" to={`${language ? language : ''}/terms/`}>{t('footer.links.termsOfUse')}</Link></div>
                <div><Link className="font12 semibold link opacity3 uppercase spacing15 bottom20" to={`${language ? language : ''}/privacy/`}>{t('footer.links.privacyPolicy')}</Link></div>
          		</div>
          	</div>
          </div>


          <header className="padding_top100">
          	<nav className="navigation_16 transparent padding_top30 padding_bottom15">
          		<div className="container-fluid nopadding line_height50">
          			<div className="row">
          				<div className="col-xl-8 text-center">
          				  <Link to={`/${i18n.language === 'en' ? '' : i18n.language}`} className="logo right20"></Link>
          		      <Link className="link semibold uppercase sides20" to={`/${language}/features`} activeClassName="blue">{t('menu.howitworks')}</Link>
          		      <Link className="link semibold uppercase sides20" to={`/${language === 'en' ? '' : language}/#references`} partiallyActive={true} activeClassName="blue">{t('menu.references')}</Link>
          		      <Link className="link semibold uppercase sides20" to={`/${language === 'en' ? '' : language}/#pricing`} partiallyActive={true} activeClassName="blue">{t('menu.pricing')}</Link>
                    <Link className="link semibold uppercase sides20" to={`/${language}/about`} activeClassName="blue">{t('menu.about')}</Link>
                    <div className="float_right">
            		      <Link className="link semibold uppercase sides10" to={path === '/' ? '/' : `/en/${path}`} onClick={()=>{i18n.changeLanguage('en')}}>EN</Link>
            		      <span className="">|</span>
            		      <Link className="link semibold uppercase sides10" to={`/fi/${path}`} onClick={()=>{i18n.changeLanguage('fi')}}>FI</Link>
          				  </div>
          				</div>
          				<div className="col-xl-4 block_right">
          					<a href={`https://app.duuers.com/auth/login?lng=${i18n.language}`} className="link semibold uppercase sides20">{t('menu.login')}</a>
          					<a href={`https://app.duuers.com/auth/signup?lng=${i18n.language}`} className="btn size50 padding_sides10 radius6 green semibold uppercase left20">{t('menu.signup')}</a>
          				</div>
          			</div>
          		</div>
          	</nav>
          </header>
      </div>
    )

  }
}

export default withTranslation()(Header);
